import { features } from '@kdcloudjs/table';

function useFooterDataSource(pipeline, footerDataSource) {
  if (footerDataSource) {
    pipeline.use(features.footerDataSource({
      dataSource: footerDataSource
    }));
  }
}

export default useFooterDataSource;